import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import DomPurify from "dompurify";

import { Section } from "@roqua/components/sections";

import { RegistrationForm } from "@/components/SelfRegistrations/RegistrationForm";
import { graphql } from "@/gql";
import { useClient } from "@/graphql/client";

const Query = graphql(/* GraphQL */ `
  query registrationPage($slug: String!) {
    selfRegistrationPage(slug: $slug) {
      id
      slug
      title
      intro
      logoUrl

      allowSignups
      signupsClosedMessage

      respondentFields {
        key
        required
      }
      demographicsFields {
        key
        required
      }
      metadataFields {
        key
        label
        required
      }
    }
  }
`);

export const Route = createFileRoute("/registration/$slug/register")({
  component: RouteComponent,
});

function RouteComponent() {
  const client = useClient();
  const { slug } = Route.useParams();
  const {
    data: { selfRegistrationPage },
  } = useSuspenseQuery({
    queryKey: ["Registration", slug],
    queryFn: () => client.request(Query, { slug }),
  });

  return (
    <main className="">
      <Section variant="header">
        {selfRegistrationPage.logoUrl && (
          <div className="mb-4 flex justify-center">
            <img src={selfRegistrationPage?.logoUrl} alt="" width="400" height="200" />
          </div>
        )}
        <h2 className="mb-4 text-xl">{selfRegistrationPage.title}</h2>
        <div dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(selfRegistrationPage.intro) }} />
      </Section>
      <Section variant="content">
        {selfRegistrationPage.allowSignups ? (
          <RegistrationForm selfRegistrationPage={selfRegistrationPage} />
        ) : (
          <div
            className="text-lg"
            dangerouslySetInnerHTML={{
              __html: DomPurify.sanitize(
                selfRegistrationPage.signupsClosedMessage ??
                  "Aanmeldingen zijn niet meer mogelijk.",
              ),
            }}
          />
        )}
      </Section>
    </main>
  );
}
